import { useQuery } from "@tanstack/react-query";
import boardService from "../api/boardService";

export const useBoard = (id) => {
  const { getBoard } = boardService();

  return useQuery({
    queryKey: ["get-board", id],
    queryFn: async () => {
      const res = await getBoard(id);
      return res.data;
    },
    enabled: !!id,
  });
};

export const useBoards = () => {
  const { getBoards } = boardService();

  return useQuery({
    queryKey: ["get-boards"],
    queryFn: async () => {
      const res = await getBoards();
      return res.data;
    },
  });
};

export const useBoardsSettings = () => {
  const { getBoardSettings } = boardService();

  return useQuery({
    queryKey: ["get-boards-settings"],
    queryFn: async () => {
      const res = await getBoardSettings();
      return res.data;
    },
  });
};

export const useBoardPermissions = (id, includeUnsubscribed = false) => {
  const { getBoardPermissions } = boardService();

  return useQuery({
    queryKey: ["get-board-permissions", id, includeUnsubscribed],
    queryFn: async () => {
      const res = await getBoardPermissions(id, includeUnsubscribed);
      return res.data;
    },
    enabled: !!id,
  });
};

export const useUserBoardPermissions = () => {
  const { getUserBoardPermissions } = boardService();

  return useQuery({
    queryKey: ["get-user-board-permissions"],
    queryFn: async () => {
      const res = await getUserBoardPermissions();
      return res.data;
    },
  });
};

export const useBoardCustomFields = (id) => {
  const { getBoardCustomFields } = boardService();

  return useQuery({
    queryKey: ["get-board-custom-fields"],
    queryFn: async () => {
      const res = await getBoardCustomFields(id);
      return res.data;
    },
    enabled: !!id,
  });
};
